import { UseMutationOptions } from "@tanstack/react-query";

import { useDeletePinnedView } from "lib/hooks/api/pinned_views/useDeletePinnedView";
import { createSavedViewUnpinnedEvent } from "lib/savedViewTracking";
import { EventNames, useTracking } from "lib/tracking";

type Params = {
  id: string;
  name: string;
};

export function useUnpinView(options?: UseMutationOptions<unknown, unknown, Params, unknown>) {
  const { logEvent } = useTracking();
  const { mutate: deletePinnedView, ...rest } = useDeletePinnedView();

  const mutate = (
    { id, name }: Params,
    callOptions?: { onSuccess?: () => void; onError?: () => void },
  ) => {
    deletePinnedView(
      { input: { savedViewId: id } },
      {
        onSuccess: (data, _vars, ctx) => {
          logEvent(
            EventNames.savedViewUnpinned,
            createSavedViewUnpinnedEvent("Pinned View reordered", name, name),
          );
          options?.onSuccess?.(data, { id, name }, ctx);
          callOptions?.onSuccess?.();
        },
        onError: (err, _vars, ctx) => {
          options?.onError?.(err, { id, name }, ctx);
          callOptions?.onError?.();
        },
      },
    );
  };

  return { mutate, ...rest };
}
